
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { UrlHistoryService } from 'src/app/service/url-history.service';
import { logInteraction } from 'src/app/utils/newrelic.util';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-unauthorized',
    templateUrl: './unauthorized.component.html',
    styleUrls: ['./unauthorized.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class UnauthorizedComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private urlHistoryService = inject(UrlHistoryService);

  attemptedUrl: string | null = null;
  accessTime: string = '';
  attemptedUrls: string[] = [];

  ngOnInit(): void {
    this.attemptedUrls = this.urlHistoryService.getLastRoutes();
    console.log('Last attempted URLs:', this.attemptedUrls?.join('-->'));
    this.accessTime = new Date().toLocaleString();
    console.log(`Unauthorized access attempt at ${this.accessTime}`);
    // Send to New Relic using logInteraction
    logInteraction(
      'Navigation Event',
      'User navigated to unauthorized page',
      [
        { accessTime: this.accessTime },
        { attemptedUrls: this.attemptedUrls.join(' -> ') }
      ]
    );
  }
}
